import {NgModule} from "@angular/core";
import {ApiResourceModule} from "../../apiResource/apiResource.module";
import {DashboardResourceService} from "libraries/service/resources/dashboard/dashboard-resource.service";

@NgModule({
    imports: [
        ApiResourceModule,
    ],
    providers: [
        DashboardResourceService
    ]
})
export class DashboardResourceModule {}
